export default [
  { id: "AC", name: "冷氣" },
  { id: "TV", name: "電視" },
  { id: "set-top-box", name: "機上盒" },
  { id: "DVD-player", name: "DVD" },
  { id: "audio-equipment", name: "音響" },
  { id: "ceiling-light", name: "吸頂燈" },
  { id: "fan", name: "風扇" },
  { id: "robovac", name: "掃地機器人" }
];
